import type { ApiConfig, RequestInterceptor, ResponseInterceptor } from '@/libs/api/types';
import axios, { type AxiosInstance } from 'axios';

const DEFAULT_TIMEOUT = 15_000;

export function createApiClient(config: ApiConfig): AxiosInstance {
  const instance = axios.create({
    baseURL: config.baseURL,
    timeout: config.timeout ?? DEFAULT_TIMEOUT,
    headers: {
      'Content-Type': 'application/json',
      Accept: 'application/json',
      ...config.headers,
    },
  });

  return instance;
}

export function applyInterceptors(
  instance: AxiosInstance,
  requestInterceptors: RequestInterceptor[] = [],
  responseInterceptors: ResponseInterceptor[] = [],
): void {
  requestInterceptors.forEach(({ onFulfilled, onRejected }) => {
    instance.interceptors.request.use(onFulfilled, onRejected);
  });

  responseInterceptors.forEach(({ onFulfilled, onRejected }) => {
    instance.interceptors.response.use(onFulfilled, onRejected);
  });
}
